// extracted by mini-css-extract-plugin
export default {"hero":"hero__Hkmpg","wrapper":"wrapper__MtXi7"};